import { Breadcrumbs, Link, Typography } from "@mui/material";
import RefreshButton from "../../../../../common/components/refresh_button";
import StatCard from "../../../../../common/components/statCard";
import PrincipaisDocGrid from "../../../../../common/components/principaisDocGrid";
import { useQualidadePrincipalViewModel } from "../../viewModels/qualidade_principal_view_model";

export const PrincipalQualidade = () => {

  const viewModel = useQualidadePrincipalViewModel();
  return (
    <>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Qualidade
            </Link>
            <Typography className="text-primary-green">
              Principal
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Principal</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full mt-4">
            {viewModel.stats.map((stat, index) => (
              <StatCard
                key={index}
                title={stat.title}
                value={Number(stat.value)}
                icon={stat.icon}
                colorClass={stat.colorClass}
                linkText={stat.linkText}
                onClick={stat.onClick}
              />
            ))}
          </div>
          <PrincipaisDocGrid
            loading={viewModel.loading}
            rows={viewModel.docLista}
            totalItems={viewModel.pagination.totalItems}
            page={viewModel.pagination.page}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onPageChange={(p) => viewModel.handlePageChange(p)}
            onRowsPerPageChange={(p) => viewModel.handleRowsPerPageChange(p)}
            onActionExportar={(IdArquivoModulo, NomeArquivo) => viewModel.handleDownloadFile(IdArquivoModulo, NomeArquivo)}
          />
        </div>
      </form>
    </>
  )
};
